/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable, QueryList} from '@angular/core';
import {WizardHeaderAction} from '../wizard-header-action';
import {WizardNavigationService} from './wizard-navigation';
export class HeaderActionService {
/**
 * @param {?} navService
 */
constructor(public navService: WizardNavigationService) {}
public wizardHeaderActions: QueryList<WizardHeaderAction>;
/**
 * @return {?}
 */
public get wizardHasHeaderActions(): boolean {
        const /** @type {?} */ wizardHdrActions = this.wizardHeaderActions;
        if (!wizardHdrActions) {
            return false;
        }
        return wizardHdrActions.toArray().length > 0;
    }
/**
 * @return {?}
 */
public get currentPageHasHeaderActions(): boolean {
        return this.navService.currentPage ? this.navService.currentPage.hasHeaderActions : false;
    }
/**
 * @return {?}
 */
public get showWizardHeaderActions(): boolean {
        return !this.currentPageHasHeaderActions && this.wizardHasHeaderActions;
    }
/**
 * @return {?}
 */
public get displayHeaderActionsWrapper(): boolean {
        return this.currentPageHasHeaderActions || this.wizardHasHeaderActions;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: WizardNavigationService, },
];
}

function HeaderActionService_tsickle_Closure_declarations() {
/** @type {?} */
HeaderActionService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderActionService.ctorParameters;
/** @type {?} */
HeaderActionService.prototype.wizardHeaderActions;
/** @type {?} */
HeaderActionService.prototype.navService;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
